'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiInfinity = function TiInfinity(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.4 14.3c-1.9 0-3.7 0.8-5.1 2.1l-2.3 2.2-2.3-2.2c-1.3-1.3-3.2-2.1-5.1-2.1s-3.7 0.8-5.1 2.1c-1.3 1.4-2.1 3.2-2.1 5.1 0 1.9 0.8 3.8 2.1 5.1 1.4 1.4 3.2 2.1 5.1 2.1 1.9 0 3.7-0.7 5.1-2.1l2.3-2.2 2.3 2.2c1.4 1.4 3.2 2.1 5.1 2.1s3.7-0.7 5.1-2.1c1.3-1.3 2.1-3.2 2.1-5.1s-0.8-3.7-2.1-5.1c-1.4-1.3-3.2-2.1-5.1-2.1z m-12.6 9.4c-1.2 1.1-3.2 1.1-4.3 0-0.6-0.6-0.9-1.4-0.9-2.2 0-0.8 0.3-1.5 0.9-2.1 0.5-0.6 1.3-0.9 2.1-0.9s1.6 0.3 2.2 0.9l2.2 2.1-2.2 2.2z m14.7 0c-1.1 1.1-3.1 1.1-4.3-0.1l-2.2-2.1 2.2-2.1c1.2-1.2 3.2-1.2 4.3 0 0.6 0.6 0.9 1.3 0.9 2.1s-0.3 1.6-0.9 2.2z' })
        )
    );
};

exports.default = TiInfinity;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/infinity.js
// module id = 2085
// module chunks = 0